import React, { ReactNode, useEffect, useRef } from 'react';
import './index.scss';
type PopModalProps = {
  title?: string;
  visible: boolean;
  hasClose?: boolean;
  handleClose: AnyFunc;
  children: ReactNode;
  targetRef?: any;
  popStyle: any;
  arrowStyle: any;
  autoClose?: boolean;
};

const PopModal = (props: PopModalProps) => {
  const {
    visible,
    hasClose,
    popStyle,
    handleClose,
    targetRef,
    title,
    arrowStyle,
    autoClose = true,
  } = props;
  const popRef = useRef<any>(null);
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [visible]);
  const handleDocumentClick = (e: Event) => {
    if (!popRef.current || !autoClose) return;
    // 点击弹窗之内的和button，不关闭；点击弹窗之外的，关闭popModal
    if (
      !popRef.current.contains(e.target as Node) &&
      popRef.current !== e.target &&
      !targetRef.current.contains(e.target as Node) &&
      targetRef.current !== e.target
    ) {
      handleClose(visible);
    }
  };
  return (
    <>
      {visible && (
        <div className='pop-modal-container' ref={popRef} style={popStyle}>
          <div className='title-container'>
            {title && <div className='title-box'>{title}</div>}
            {hasClose && (
              <i
                className='close-btn'
                onClick={() => {
                  handleClose(visible);
                }}
              >
                X
              </i>
            )}
          </div>
          <>{props.children}</>
          <div className='pop-arrow' style={arrowStyle}></div>
        </div>
      )}
    </>
  );
};

export default React.memo(PopModal);
